import { CreditCard } from "../types/customer.types";

export interface CreditCardImage {
    src: string;
    alt: string;
    type: string;
}

export const creditCards: CreditCardImage[] = [
    {
        src: "/icons/visa.png",
        alt: CreditCard.Visa,
        type: "visa",
    },
    {
        src: "/icons/mastercard.png",
        alt: CreditCard.Mastercard,
        type: "mastercard",
    },
    {
        src: "/icons/amex.png",
        alt: CreditCard.AmericanExpress,
        type: "american-express",
    },
    {
        src: "/icons/discover.png",
        alt: CreditCard.Discover,
        type: "discover",
    },
];

export function getAcceptedCreditCards(acceptedCreditCards: CreditCard[]): CreditCardImage[] {
    return creditCards.filter(card => acceptedCreditCards.includes(card.alt as CreditCard));
}